import moment from 'moment';

/**
 * Set global so you don't have to import it
 */
window.moment = moment;
